import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const PlusIcon = (props: IconProps) => {
  const { color = FORTA_BLUE.primary } = props;

  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.0287 3.29752C22.1046 7.35746 22.1176 13.953 18.0576 18.0289C13.9977 22.1048 7.40218 22.1177 3.32628 18.0578C-0.749654 13.9978 -0.762553 7.40231 3.29739 3.32642C7.35736 -0.749517 13.9528 -0.762453 18.0287 3.29752ZM16.5585 4.77355C13.2978 1.52557 8.02139 1.53592 4.77341 4.79666C1.52542 8.05743 1.53578 13.3338 4.79653 16.5818C8.05729 19.8298 13.3336 19.8194 16.5816 16.5586C19.8296 13.2979 19.8193 8.02154 16.5585 4.77355ZM11.7111 6.50897L11.7172 9.63388L14.8422 9.62776C15.4174 9.62661 15.8847 10.0921 15.8859 10.6674C15.887 11.2426 15.4215 11.7099 14.8462 11.7111L11.7213 11.7172L11.7274 14.8423C11.7285 15.4176 11.2631 15.8849 10.6878 15.886C10.1125 15.8871 9.64523 15.4216 9.64411 14.8464L9.63798 11.7213L6.5129 11.7274C5.93762 11.7285 5.47034 11.2631 5.46919 10.6878C5.46805 10.1125 5.93353 9.64523 6.5088 9.64412L9.63389 9.63797L9.62775 6.51305C9.62662 5.93776 10.0921 5.47048 10.6674 5.46934C11.2427 5.46822 11.7099 5.93367 11.7111 6.50897Z"
        fill={color}
      />
    </svg>
  );
};

export default PlusIcon;
